import * as React from 'react';

import styles from './RemarkCard.module.css';
import { Pill } from '../Pill/Pill';

export interface RemarkPillSpec {
    label: React.ReactNode;
    bg: string;
    color: string;
    dot?: string;
}

export interface RemarkCardProps {
    code?: number;
    category?: RemarkPillSpec;
    sheet?: React.ReactNode;
    /** Подпись перед значением листа/пункта. По умолчанию «Лист»; для ТЗ — «Пункт ТЗ». */
    sheetLabel?: string;
    status?: RemarkPillSpec;
    /** raw html body (note Title); use `body` for a React node instead */
    bodyHtml?: string;
    body?: React.ReactNode;
    attachmentSlot?: React.ReactNode;
    replySlot?: React.ReactNode;
    actionsSlot?: React.ReactNode;
    /** Квадратная кнопка-иконка «открыть» перед номером (по макету pda-design). */
    openIcon?: boolean;
    /** Слева в верхней строке шапки (например, чекбокс выбора у ГИП). */
    headerTopStart?: React.ReactNode;
    /**
     * Дополнительные метки в шапке рядом с категорией и листом: у порталов там
     * бывает больше, чем в макете (критичность, теги, «Назначено на …»).
     */
    headerExtras?: React.ReactNode;
    date?: React.ReactNode;
    author?: React.ReactNode;
    commentsCount?: number;
    className?: string;
    onFormClick?: (e: any) => void;
}

//Замечание
export const RemarkCard: React.FC<RemarkCardProps> = ({
    code,
    category,
    sheet,
    sheetLabel = 'Лист',
    status,
    bodyHtml,
    body,
    attachmentSlot,
    replySlot,
    actionsSlot,
    openIcon,
    headerTopStart,
    headerExtras,
    date,
    author,
    commentsCount,
    className,
    onFormClick
}) => (
    <div className={`${styles.card}${className ? ` ${className}` : ``}`}>
        <div className={styles.header}>
            <div className={styles.headerTop} onClick={onFormClick}>
                <div className={styles.headerTopLead}>
                    {headerTopStart != null && (
                        <span className={styles.headerTopStart} onClick={(e) => e.stopPropagation()}>
                            {headerTopStart}
                        </span>
                    )}
                    <span className={styles.code}>
                        {openIcon && (
                            <span className={styles.openIcon} aria-hidden="true">
                                <i className="fa-solid fa-arrow-up-right-from-square" />
                            </span>
                        )}
                        <span role="link" style={{ cursor: `pointer` }}  title="Открыть замечание">
                            {code}
                        </span>
                    </span>
                </div>
                {status && <Pill label={status.label} bg={status.bg} color={status.color} dotColor={status.dot} />}
            </div>
            {(category || sheet != null || headerExtras) && (
                <div className={styles.headerMeta}>
                    {category && (
                        <Pill
                            label={category.label}
                            bg={category.bg}
                            color={category.color}
                            dotColor={category.dot}
                            className={styles.category}
                        />
                    )}
                    {sheet != null && (
                        <span className={styles.sheet}>
                            {sheetLabel}: <b>{sheet}</b>
                        </span>
                    )}
                    {headerExtras}
                </div>
            )}
        </div>

        <div className={styles.body}>
            {body ??
                (bodyHtml != null && <div className={styles.text} dangerouslySetInnerHTML={{ __html: bodyHtml }} />)}
            {attachmentSlot}
            {replySlot}
        </div>

        {(actionsSlot || date || author || commentsCount != null) && (
            <div className={styles.footer}>
                {actionsSlot}
                <div className={styles.meta}>
                    {(date || author) && (
                        <span className={styles.metaText}>
                            {date}
                            {date && author ? ', ' : ''}
                            {author && <b>{author}</b>}
                        </span>
                    )}
                    {commentsCount != null && (
                        <span className={styles.comments} onClick={onFormClick}>
                            <i className="fa-regular fa-comments" />
                            {commentsCount}
                        </span>
                    )}
                </div>
            </div>
        )}
    </div>
);
